export class ConfigDB {
    static data = {
      settings: {
        layout_type: 'ltr',
        layout_class: 'compact-wrapper',
        sidebar: {
          iconType: 'fill',
        },
        sidebar_setting: 'default-sidebar',
      },
      color: {
        primary_color:'#5C61F2',
        secondary_color: '#FF9766',
        mix_background_layout: 'dark-sidebar',
      }
    };
  }
  export default ConfigDB;